import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
import { toast } from 'react-hot-toast';

export const useUpdateKycStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sellerServices.updateKycStatus,
    onSuccess: (data, variables) => {
      toast.success('KYC status updated successfully');
      queryClient.invalidateQueries({ queryKey: ['seller', variables.sellerId] });
      queryClient.invalidateQueries({ queryKey: ['sellers'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update KYC status');
    },
  });
};
